export const toReadableTemplateFileKey = (key) =>
  key?.replace(/spo_sjabloon_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/gim, '') ?? '';

export const getTemplateCategory = (fileType, categorySuffix) => `${fileType}_${categorySuffix}`;
